<template>
  <div class="toast" :class="type">
    {{ message }}
  </div>
</template>

<script setup>
import { onMounted } from 'vue';

const props = defineProps({
  message: String,
  type: { type: String, default: 'success' },
  duration: { type: Number, default: 3000 }
});

const emit = defineEmits(['close']);

onMounted(() => {
  setTimeout(() => {
    emit('close');
  }, props.duration);
});
</script>

<style scoped>
.toast {
  position: fixed;
  bottom: 80px; /* Un poco arriba del menú inferior */
  left: 50%;
  transform: translateX(-50%);
  background: #333;
  color: white;
  padding: 12px 24px;
  border-radius: 50px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  z-index: 3000;
  font-size: 14px;
  font-weight: 500;
  animation: fadeIn 0.3s ease;
}
.toast.success { background: #059669; }
.toast.error { background: #dc2626; }

@keyframes fadeIn {
  from { opacity: 0; transform: translate(-50%, 10px); }
  to { opacity: 1; transform: translate(-50%, 0); }
}
</style>